import { gql } from '@apollo/client';

export const FILTERED_CIRCUITS = gql`
  query FilteredCircuits($input: ExportArgs!) {
    circuits: allCircuits(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
